import { FormInput } from "@holigral/shared/form"
import { useT } from "@/i18n"
import { FormMarkdownEditor } from "@/form"

/**
 * Shared name + description fields for the create and edit dialogs. The
 * description is markdown, edited with the same MDXEditor as evaluations.
 */
export default function BriefFormFields() {
  const { t } = useT("brief")

  return (
    <div className="flex flex-col gap-4">
      <FormInput name="name" label={t("form.name")} required />
      <FormMarkdownEditor
        name="description"
        label={t("form.description")}
        helperText={t("form.descriptionHelp")}
      />
    </div>
  )
}
